/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyContact } from './EmergencyContact';
import {
    EmergencyContactFromJSON,
    EmergencyContactFromJSONTyped,
    EmergencyContactToJSON,
    EmergencyContactToJSONTyped,
} from './EmergencyContact';

/**
 * 
 * @export
 * @interface CreateEmergencyContactResponse
 */
export interface CreateEmergencyContactResponse {
    /**
     * 
     * @type {EmergencyContact}
     * @memberof CreateEmergencyContactResponse
     */
    data: EmergencyContact;
}

/**
 * Check if a given object implements the CreateEmergencyContactResponse interface.
 */
export function instanceOfCreateEmergencyContactResponse(value: object): value is CreateEmergencyContactResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateEmergencyContactResponseFromJSON(json: any): CreateEmergencyContactResponse {
    return CreateEmergencyContactResponseFromJSONTyped(json, false);
}

export function CreateEmergencyContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmergencyContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmergencyContactFromJSON(json['data']),
    };
}

  export function CreateEmergencyContactResponseToJSON(json: any): CreateEmergencyContactResponse {
      return CreateEmergencyContactResponseToJSONTyped(json, false);
  }

  export function CreateEmergencyContactResponseToJSONTyped(value?: CreateEmergencyContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmergencyContactToJSON(value['data']),
    };
}

